/* Glambe order-value helpers: savings banner, gift unlock bar, bestie share chip (product page) */
(function () {
  var cfg = document.getElementById('gbfx-cfg'); if (!cfg || window.__gbgrow) return; window.__gbgrow = 1;
  var gift = '', gTier = parseInt(cfg.dataset.gifttier, 10) || 3;
  var share = cfg.dataset.share === '1', shareText = (cfg.dataset.sharetext || '').trim() || 'Bestie, look at this';
  var css = document.createElement('style');
  css.textContent = '.gbsave{margin:10px 0 0;padding:12px 14px;border-radius:16px;background:linear-gradient(120deg,rgba(127,102,184,.14),rgba(245,163,208,.22));display:flex;align-items:center;gap:10px;font-size:14px;color:#3A2D5C;animation:gbg-pop .6s cubic-bezier(.3,1.6,.5,1)}' +
    '.gbsave b{font-size:15.5px;color:#5A3FA0}' +
    '.gbg{margin:10px 0 0;padding:12px 14px;border-radius:16px;border:1.5px dashed rgba(127,102,184,.5);background:rgba(127,102,184,.07);display:flex;align-items:center;gap:12px;font-size:13.5px;line-height:1.4;cursor:pointer;transition:all .35s;color:#3A2D5C}' +
    '.gbg__i{font-size:24px;display:inline-block;animation:gbg-bob 2.2s ease-in-out infinite}' +
    '.gbg.is-on{border-style:solid;border-color:transparent;background:linear-gradient(120deg,#7F66B8,#B79CE6);color:#fff;animation:gbg-pop .6s cubic-bezier(.3,1.6,.5,1)}' +
    '.gbg b{font-weight:600}' +
    '.gbs-share{margin:10px 0 0;display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:12px 14px;border-radius:99px;border:1.5px solid rgba(127,102,184,.4);background:#fff;color:#4B3A78;font:inherit;font-size:13.5px;cursor:pointer;transition:transform .25s,box-shadow .25s}' +
    '.gbs-share:hover{transform:translateY(-2px);box-shadow:0 10px 24px -12px rgba(127,102,184,.6)}' +
    '.es-sticky-btn{display:none!important}' +
    '@keyframes gbg-bob{0%,100%{transform:translateY(0) rotate(-6deg)}50%{transform:translateY(-4px) rotate(6deg)}}' +
    '@keyframes gbg-pop{0%{transform:scale(.94)}60%{transform:scale(1.04)}100%{transform:scale(1)}}' +
    '@media (prefers-reduced-motion:reduce){.gbg__i,.gbg.is-on,.gbsave{animation:none}}';
  document.head.appendChild(css);
  var box = null, sv = null, btn = null, tries = 0;
  function tiers() { return [].slice.call(document.querySelectorAll('.gbp__tier')); }
  function anchor() { return document.querySelector('.gbp__nudge') || document.querySelector('.gbp__meter') || document.querySelector('.gbp__tiers'); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function sel() { var c = document.querySelector('.gbp__tier input:checked'); return c ? parseInt(c.value, 10) : 1; }
  function num(t) { var m = String(t || '').match(/\d[\d,]*\.?\d*/); return m ? parseFloat(m[0].replace(/,/g, '')) || 0 : 0; }
  function updSave() {
    if (!sv) return; var t = document.querySelector('.gbp__tier input:checked'); t = t && t.closest('.gbp__tier');
    if (!t) { sv.hidden = true; return; }
    var n = t.querySelector('[data-tnow]'), w = t.querySelector('[data-twas]');
    var nt = n ? n.textContent.trim() : '', a = num(nt), b = w && !w.hidden ? num(w.textContent) : 0;
    var d = b - a; if (d <= 0.009) { sv.hidden = true; return; }
    var pre = (nt.match(/^[^0-9]*/) || [''])[0], pct = Math.round(d / b * 100);
    sv.hidden = false; sv.innerHTML = '<span aria-hidden="true" style="font-size:22px">🎉</span><span>You are saving <b>' + esc(pre + d.toFixed(2)) + '</b> (' + pct + '% off) on this order</span>';
  }
  function update() {
    updSave();
    if (!box) return; var ts = tiers(), t = ts[gTier - 1]; if (!t) { box.hidden = true; return; }
    var need = parseInt(t.dataset.qty, 10), name = esc(gift);
    var lb = t.querySelector('.gbp__tl b'), lab = lb && lb.firstChild ? lb.firstChild.textContent.trim() : ('Buy ' + need);
    var on = sel() >= need; box.classList.toggle('is-on', on);
    box.innerHTML = '<span class="gbg__i" aria-hidden="true">🎁</span><span>' + (on ? '<b>Free ' + name + ' unlocked!</b> It will be added to your order.' : 'Pick the <b>' + esc(lab) + ' (' + need + ')</b> and get a <b>free ' + name + '</b>') + '</span>';
  }
  function build() {
    var a = anchor();
    if (!a) { if (++tries < 40) setTimeout(build, 300); return; }
    var after = a;
    sv = document.createElement('div'); sv.className = 'gbsave'; after.parentNode.insertBefore(sv, after.nextSibling); after = sv;
    if (gift) {
      box = document.createElement('div'); box.className = 'gbg'; after.parentNode.insertBefore(box, after.nextSibling); after = box;
      box.addEventListener('click', function () { var t = tiers()[gTier - 1]; if (t) t.click(); });
    }
    update();
    document.addEventListener('change', function (e) { if (e.target && e.target.name && e.target.name.indexOf('gbp-tier') === 0) setTimeout(update, 0); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.gbp__tier,.gbp__nudge')) setTimeout(update, 40); });
    if (share) {
      btn = document.createElement('button'); btn.type = 'button'; btn.className = 'gbs-share';
      btn.innerHTML = '<span aria-hidden="true">💌</span> Send this to your bestie';
      var atc = document.querySelector('.gbp__atc'); if (atc && atc.parentNode) { atc.parentNode.insertBefore(btn, atc.nextSibling); } else { after.parentNode.insertBefore(btn, after.nextSibling); }
      var mv = 0, iv = setInterval(function () { var es = document.querySelector('.es-popup-button'); if (es && es.parentNode && es.offsetHeight) { if (es.nextElementSibling !== btn) es.parentNode.insertBefore(btn, es.nextSibling); clearInterval(iv); } else if (++mv > 40) { clearInterval(iv); } }, 300);
      btn.addEventListener('click', function () {
        var url = location.origin + location.pathname;
        if (navigator.share) { navigator.share({ title: document.title, text: shareText, url: url }).catch(function () {}); }
        else { window.open('https://wa.me/?text=' + encodeURIComponent(shareText + ' ' + url), '_blank', 'noopener'); }
      });
    }
  }
  build();
})();

/* Serum drop on the skin patch (home page ampoule scene): big glossy drop falls onto the patch, then ripples and sparkles */
(function () {
  var d = document.getElementById('gbs-drop'), sw = document.getElementById('gbs-sw');
  if (!d || !sw || !d.animate) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  var st = document.createElement('style');
  st.textContent = '.gbd-drop{position:fixed;left:0;top:0;width:26px;height:36px;margin:-18px 0 0 -13px;border-radius:50% 50% 50% 50%/62% 62% 38% 38%;z-index:99999;pointer-events:none;background:radial-gradient(circle at 36% 30%,#fff 0,#eadffc 38%,#b79ce6 78%,#8e74c6 100%);box-shadow:0 0 18px 4px rgba(183,156,230,.6),inset -3px -4px 6px rgba(127,102,184,.35);will-change:transform}' +
    '.gbd-rip{position:fixed;left:0;top:0;width:30px;height:30px;margin:-15px 0 0 -15px;border-radius:50%;border:2px solid rgba(255,255,255,.95);box-shadow:0 0 14px rgba(183,156,230,.8);z-index:99999;pointer-events:none}';
  document.head.appendChild(st);
  var was = false, busy = false;
  function vis() { return parseFloat(getComputedStyle(d).opacity) > 0.5; }
  function target() { var s = sw.getBoundingClientRect(); return { x: s.left + s.width / 2, y: s.top + s.height / 2, ok: s.width > 10 }; }
  function fire() {
    var t0 = target(); if (!t0.ok || t0.y < -50 || t0.y > innerHeight + 50) return;
    busy = true;
    var el = document.createElement('div'); el.className = 'gbd-drop'; document.body.appendChild(el);
    var start = performance.now(), dur = 850, tx = t0.x, ty = t0.y;
    function frame(now) {
      var k = Math.min(1, (now - start) / dur), t = target(); tx = t.x; ty = t.y;
      var e = k * k * (1.4 - 0.4 * k), y = ty - 190 + 190 * e;
      var op = k < 0.12 ? k / 0.12 : 1, sc = 0.4 + 0.6 * Math.min(1, k * 4);
      el.style.opacity = op; el.style.transform = 'translate(' + tx + 'px,' + y + 'px) scale(' + (sc * (1 - 0.1 * k)) + ',' + (sc * (1 + 0.3 * k)) + ')';
      if (k < 1) { requestAnimationFrame(frame); } else { land(); }
    }
    function land() {
      el.remove();
      for (var i = 0; i < 3; i++) {
        var rp = document.createElement('div'); rp.className = 'gbd-rip'; document.body.appendChild(rp);
        (function (rp, i) {
          var b = rp.animate([
            { transform: 'translate(' + tx + 'px,' + ty + 'px) scale(.2)', opacity: 1 },
            { transform: 'translate(' + tx + 'px,' + ty + 'px) scale(' + (3.2 + i) + ')', opacity: 0 }
          ], { duration: 900, delay: i * 170, easing: 'ease-out', fill: 'both' });
          b.onfinish = function () { rp.remove(); };
        })(rp, i);
      }
      if (window.gbfxBurst) { try { window.gbfxBurst(tx, ty, 16, false); } catch (e) {} }
      setTimeout(function () { busy = false; }, 1400);
    }
    requestAnimationFrame(frame);
  }
  new MutationObserver(function () { var v = vis(); if (v && !was && !busy) fire(); was = v; }).observe(d, { attributes: true, attributeFilter: ['style'] });
})();
